import axios from 'axios';

const API = axios.create({
    baseURL: 'https://expenseflow-backend-kxut.onrender.com/api',
});

// Automatically attach JWT token to every request
API.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Auth
export const registerUser = (data) => API.post('/register', data);
export const loginUser = (data) => API.post('/login', data);

// Expenses
export const getExpenses = (month) => API.get(`/expenses${month ? `?month=${month}` : ''}`);
export const addExpense = (data) => API.post('/expenses', data);
export const deleteExpense = (id) => API.delete(`/expenses/${id}`);
export const getSummary = (month) => API.get(`/expenses/summary${month ? `?month=${month}` : ''}`);